var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgDirectionSigns = function SvgDirectionSigns(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Direction Signs' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 25 25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 14.953l-3.386-3.255h-6.138v-1.86h5.714V3.325h-5.714V1h-.952v2.326H6.386L3 6.58l3.386 3.256h6.138v1.86H6.81v6.512h5.714v5.117h.952v-5.117h6.138L23 14.953zM4.405 6.581l2.352-2.325h11.481v4.651H6.758L4.404 6.581zM7.762 17.28v-4.651h11.48l2.353 2.325-2.352 2.326H7.762z"
  }));
};
SvgDirectionSigns = pure(SvgDirectionSigns);
SvgDirectionSigns.displayName = 'SvgDirectionSigns';
export default SvgDirectionSigns;